<template>
  <div class="app-page__container app-page__container--no-sidebar">
    <div v-if="!isLoading" class="">
      <div class="card">
        <div class="card-content">
          Account linked,
          <a
            class="has-text-primary"
            style="text-decoration: underline;"
            @click="backToSlack()"
            @keyup.enter="backToSlack()"
          >tap here</a>
          to go back to Slack.
        </div>
      </div>
    </div>
    <div v-else style="position: relative; min-height: 150px;">
      <b-loading :is-full-page="false" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import * as UserActions from '@/store/actions/User.actions';
import * as ApiService from '@/services/Api.service';
import { getUserTeams } from '@/helpers/teamHelpers';

export default {
  name: 'SlackLinkUserView',

  props: {
    sid: {
      type: String,
    },
    ts: {
      type: String,
    },
    channel: {
      type: String,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters([
      'activeWorkspace',
      'loggedInUser',
    ]),
    ...mapState({
      teams: state => state.team.teams,
    }),
  },

  mounted() {
    this.linkSlackUser();
  },

  methods: {
    ...mapActions({
      updateUserProfile: UserActions.UPDATE_USER_PROFILE,
    }),
    backToSlack() {
      window.open('slack://open', '_blank');
      this.$router.replace('/dashboard');
    },
    async linkSlackUser() {
      const updatedUser = {
        userId: this.loggedInUser.id,
        updatedUser: {
          slackUserId: this.sid,
        },
        workspaceId: this.activeWorkspace.id,
      };

      console.log(this.sid);
      console.log(this.responseUrl);
      console.log(this.activeWorkspace.id);

      this.updateUserProfile(updatedUser)
        .then(() => {
          const teamData = getUserTeams(this.loggedInUser.id, this.teams)[0];

          /* eslint-disable quotes */
          const slackResponse = `OK! ${this.loggedInUser.firstName}, now that you've linked `
            + "your StandupPro account we can get down to business. Try asking for: \n\n"
            + "• Today's goals `/sup goals today` \n"
            + "• Yesterday's `/sup goals yesterday` \n"
            + "• Another date `/sup goals 5-11-2020` \n"
            + "• Or mark your previous goal and add a new one `/sup mygoals` \n\n"
            + "Also, you can talk to me from any channel, not just here.";
          ApiService.updateSlackMessage(teamData.slackData.access_token, this.channel, this.ts, slackResponse);
        })
        .catch(() => {

        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
